import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import {
  AnalyticsEventData,
  AnalyticsEventImportance,
  AnalyticsEventName,
  logEvent as logAnalyticsEvent,
} from '@cbhq/client-analytics';

import { PACKAGE_VERSION } from '../environment';
import { useClientProps } from '../providers/ClientPropsProvider';

function getIsURLAppSwitch() {
  if (typeof window !== 'undefined') {
    return window.location.search.includes('appswitcher=true');
  }
  return false;
}

export function useAnalytics() {
  const { projectId, action } = useClientProps();
  const { locale } = useIntl();

  const logEvent = useCallback(
    (
      eventName: AnalyticsEventName,
      eventData: AnalyticsEventData,
      eventImportance?: AnalyticsEventImportance,
    ) => {
      logAnalyticsEvent(
        eventName,
        {
          ...eventData,
          package_version: PACKAGE_VERSION as string,
          package_name: '@cbhq/identity-navigation',
          projectId,
          clientAction: action,
          locale,
          isAppSwitch: getIsURLAppSwitch(),
        },
        eventImportance,
      );
    },
    [projectId, action, locale],
  );

  return useMemo(
    () => ({
      logEvent,
    }),
    [logEvent],
  );
}
